define.alias("shared/components/shared/ui/switcher/trigger", "media/components/shared/ui/switcher/trigger");